<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" style="margin-left: 20px;" label-position="left">
          <el-form-item label="请选择Bucket:">
            <el-select v-model="bucketpath" filterable placeholder="请选择Bucket" @change="bucketchange">
              <el-option
                v-for="item in bucketpaths"
                :key="item.bucketname"
                :label="item.bucketname"
                :value="item.bucketname"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-col :span="12">
        <div class="leftpanel">
          <div>Oss路径:</div>
          <el-tree
            class="filter-tree"
            ref="pathtree"
            :data="pathdata"
            :props="pathprops"
            node-key="id"
            :check-strictly = "true"
            @node-click="pathselect"
            :render-content="pathcontext">
          </el-tree>
          <div class="desinfo"> 注意：Oss路径下文件轻易不要删除 </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="rightpanel">
          <el-collapse v-model="pathlevelactive" accordion >
            <el-collapse-item title="所选路径" name="0"> {{ selectpath }}
              <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
                <el-form-item label="新文件夹名称">
                  <el-input v-model="pathname" placeholder="仅新增一级子路径时添加"></el-input>
                </el-form-item>
                <el-button @click="addnewpath">创建新文件夹</el-button>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="selectuppathtitle" :visible.sync="upfilevis">
      <el-row class="showpcinfo">
        <el-col :span="12">
          <el-form  label-width="120px">
            <el-form-item label="上传资料" class="yyzz_upload">
              <el-upload
                class="avatar-uploader"
                drag
                action=""
                :on-success="fnUploadSuccess"
                :headers="uploadHeaders"
                :show-file-list="true"
                :http-request="fnUploadRequest"
                :limit="files">
              </el-upload>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item title="上传说明" name="1">
              <div>1、您可以上传任何类型的资料。</div>
              <div>2、上传前一定要看好上传的路径！</div>
              <div>3、上传时，上传文件下方会有上传进度。</div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import Utils from '../../util/utils'
import '../../../static/css/my.css'
var OSS = require('ali-oss')
Vue.prototype.$http = axios
var that
export default {
  name: 'OssPath',
  data () {
    return {
      osspath: [{
        value: '1',
        label: 'Images'
      }, {
        value: '12',
        label: 'Brands'
      }],
      pathdata: [],
      activeName: ['1'],
      upfilevis: false,
      bucketpaths: [],
      pathprops: {
        children: 'Children',
        label: 'path'
      },
      osspathname: '',
      selectrootpath: '',
      pathlevelactive: '0',
      mypathname: '',
      selectpathdata: '',
      selectpathnode: '',
      selectuppathtitle: '',
      selectpath: '',
      pathname: '',
      khid: '',
      uploadUrl: '',
      uploadFileLength: 0,
      uploadFileSuccess: 0,
      uploadFileNames: [],
      uploadFileName: [],
      fileList: [],
      files: 100,
      bucketpath: '',
      uploadHeaders: {
        authorization: ''
      },
      uppercent: 0,
      disabled: false
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listbucket',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var bmlist = JSON.parse(res.data.data)
            var bmdata = []
            for (var j = 0; j < bmlist.length; j++) {
              var stmp = bmlist[j]
              let datatmp = {
                bucketname: stmp
              }
              bmdata.push(datatmp)
            }
            that.bucketpaths = bmdata
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })

      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listpath',
        method: 'post',
        data: {
          bucketname: this.bucketpath
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedatas = []
            var arrdatas = JSON.parse(res.data.data)
            for (var i = 0; i < arrdatas.length; i++) {
              console.log(arrdatas[i])
              var treedata
              treedata = {
                path: arrdatas[i],
                Children: []
              }
              treedatas.push(treedata)
            }
            that.pathdata = treedatas
            console.log(JSON.parse(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  },
  methods: {
    bucketchange () {
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listpath',
        method: 'post',
        data: {
          bucketname: this.bucketpath
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedatas = []
            var arrdatas = JSON.parse(res.data.data)
            for (var i = 0; i < arrdatas.length; i++) {
              console.log(arrdatas[i])
              var treedata
              treedata = {
                path: arrdatas[i],
                Children: []
              }
              treedatas.push(treedata)
            }
            that.pathdata = treedatas
            console.log(JSON.parse(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    pathselect (data, node) {
      console.log(data.path)
      this.selectpathdata = data
      this.selectpathnode = node
      that.selectuppathtitle = '上传资料到路径：' + data.path
      this.selectpath = data.path
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/listpath',
        method: 'post',
        data: {
          bucketname: this.bucketpath,
          bucketpath: {String: data.path, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedatas = []
            var arrdatas = JSON.parse(res.data.data)
            for (var i = 0; i < arrdatas.length; i++) {
              console.log(arrdatas[i])
              if (data.path !== arrdatas[i]) {
                var treedata
                treedata = {
                  path: arrdatas[i],
                  Children: []
                }
                treedatas.push(treedata)
              }
            }
            data.Children = treedatas
            node.expanded = true
            console.log(node)
            console.log(JSON.parse(res.data.data))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    pathcontext (h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <div class="pathtreeinfo">
            {data.path}
          </div>
          <div>
            <i class="fa fa-pencil-square-o opicon" on-click={ () => this.path_edit(node, data)}> </i>
            <i class="fa fa-trash-o opicon" on-click={ () => this.path_remove(node, data)}> </i>
          </div>
        </span>
      )
    },
    addnewpath () {
      var pathtmp
      if (this.selectpath === '') {
        pathtmp = this.selectpath + this.pathname + '/'
      } else {
        pathtmp = this.selectpath + this.pathname
      }
      var addpath = {
        bucketname: this.bucketpath,
        bucketpath: {String: pathtmp, Valid: true}
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/createbucketpath',
        method: 'post',
        data: addpath,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var treedata
            treedata = {
              path: pathtmp + '/',
              Children: []
            }
            that.selectpathdata.Children.push(treedata)
            that.selectpathnode.expanded = true
            that.$message({
              type: 'success',
              message: '创建文件夹成功!'
            })
          } else {
            that.$message({
              type: 'error',
              message: '添加失败!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    path_remove (node, data) {
      console.log('开始删除')
      console.log(data.path)
      var addpath = {
        bucketname: 'wyzb1',
        bucketpath: {String: data.path, Valid: true}
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/oss/delfile',
        method: 'post',
        data: addpath,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            console.log(node)
            var dataindex = node.parent.childNodes.findIndex(d => d.data.path === data.path)
            console.log(dataindex)
            node.parent.childNodes.splice(dataindex, 1)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    path_edit (node, data) {
      console.log('直接可上传资料')
      if (that.selectuppath || that.selectuppath !== '') {
        this.upfilevis = true
      } else {
        that.$message({
          type: 'info',
          message: '请选择上传路径!'
        })
      }
    },
    randomString (num) {
      let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
      let res = ''
      for (let i = 0; i < num; i++) {
        var id = Math.ceil(Math.random() * 35)
        res += chars[id]
      }
      return res
    },

    /**
     * 创建oss客户端对象
     * @returns {*}
     */
    createOssClient () {
      return new Promise((resolve, reject) => {
        let client = new OSS({
          region: 'oss-cn-beijing',
          accessKeyId: 'LTAIK44bzZpLz0As',
          accessKeySecret: 'pWSiczyGrBXhnXIJ7Crj8GxNkkEzM0',
          bucket: 'wyzb1'
        })
        resolve(client)
      })
    },
    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @author   yangxiaoshuo
     * @param    {object}   option [上传选项]
     * @return   {null}   [没有返回]
     */
    async fnUploadRequest (option) {
      var that = this
      let file = option.file
      const self = this
      return new Promise((resolve, reject) => {
        let date = Utils.dateFormat(new Date(), 'yyyyMMdd') // 当前时间
        console.log(date)
        let dateTime = Utils.dateFormat(new Date(), 'yyyyMMddhhmmss') // 当前时间
        let randomStr = self.randomString(4)//  4位随机字符串
        let extensionName = file.name.substr(file.name.indexOf('.')) // 文件扩展名
        console.log(dateTime)
        console.log(randomStr)
        console.log(extensionName)
        let fileName = that.selectpath + file.name // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.createOssClient().then(client => {
          // 异步上传,返回数据
          resolve({
            fileName: file.name,
            fileUrl: fileName
          })
          // 上传处理
          // 分片上传文件
          client.multipartUpload(fileName, file, {
            progress: function (p) {
              let e = {}
              e.percent = Math.floor(p * 100)
              // console.log('Progress: ' + p)
              option.onProgress(e)
              that.uppercent = e.percent
              console.log(e.percent)
            }
          }).then((val) => {
            if (val.res.statusCode === 200) {
              option.onSuccess(val)
              return val
            } else {
              option.onError('上传失败')
            }
          }, err => {
            option.onError('上传失败')
            reject(err)
          })
        }).catch(errinfo => {
        })
      })
    },
    /**
     * @description [fnUploadSuccess 文件上传成功的函数]
     * @author   shanshuizinong
     * @return   {null}  [没有返回]
     */
    async fnUploadSuccess (file) {
      console.log(file)
      // TODO
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/oss/OssPath.vue